// extracted by mini-css-extract-plugin
export default {"SpecialFloorInfo_container":"styles_SpecialFloorInfo_container__1zNhb","hoistOperator":"styles_hoistOperator__3ke0E","safetyIcon":"styles_safetyIcon__VtRRC"};